import React, { useState, useEffect, useContext } from "react";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import DataCardGraphMobile from "./DataCardGraphMobile";
import DataCardMobile from "./DataCardMobile";
import DataTitleCard from "./DataTitleCard";
import GraphDataCardPaneMobile from "../GraphDataCards/GraphDataCardPaneMobile";
import Grid from "@material-ui/core/Grid";
import moment from "moment-timezone/moment-timezone";
import { useApolloClient } from "@apollo/react-hooks";
import { GET_BEST_TIME_SLICE_GEO } from "../GraphQL/GetGeoTimeSliceValues";
import { makeStyles } from "@material-ui/core/styles";

import config from "../../dashboard-config";
import { ChartDataContext } from "../../context/ChartDataContext";

import "./DataPane.scss";

const useStyles = makeStyles({
  root: {
    background: "RGB(37, 42, 63)",
    minWidth: "300px",
    minHeight: "86px",
    padding: "0"
  },
  pane: {
    margin: "0 auto",
    marginBottom: "5px",
    width: "400px",
    "@media only screen and (min-width: 1000px)": {
      display: "none"
    },
    "@media only screen and (max-width: 450px)": {
      width: "95vw"
    }
  },
  paneButton: {
    backgroundColor: "RGB(37, 42, 63)",
    borderRadius: "2px",
    border: "none",
    height: "30px",
    left: "45%",
    marginBottom: "2.5px",
    "&:hover": {
      backgroundColor: "RGB(37, 42, 63)"
    },
    "@media only screen and (max-width: 450px)": {
      left: "42.5%"
    }
  }
});

const startDate = moment()
  .subtract(3, "days")
  .startOf("day");
const endDate = moment()
  .add(3, "days")
  .endOf("day");

const DataPane = ({ selectedSpotter, spotterData, pointData }) => {
  const classes = useStyles();
  const client = useApolloClient();
  const [batchedData, setBatchedData] = useState(null);
  const [observationData, setObservationData] = useState(null);
  const { selectedData, setSelectedData } = useContext(ChartDataContext);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isPaneToggled, setIsPaneToggled] = useState(false);
  const profile = JSON.parse(localStorage.getItem("sofar-user") || "{}");

  let filteredSpotterData;

  const dataPoints = {
    waveHeight: {
      title: "wave height",
      graph: "wave",
      measurement: "ft",
      toFixed: "2"
    },
    significantWaveHeight: {
      title: "wave height",
      graph: "wave",
      measurement: "ft",
      toFixed: "2"
    },
    peakPeriod: {
      title: "peak period",
      graph: "period",
      measurement: "s",
      toFixed: "2"
    },
    meanPeriod: {
      title: "mean period",
      graph: "period",
      measurement: "s",
      toFixed: "2"
    },
    period: {
      title: "mean period",
      graph: "period",
      measurement: "s",
      toFixed: "2"
    },
    spread: {
      title: "mean spread",
      graph: "spread",
      measurement: "°",
      toFixed: "0"
    },
    peakDirection: {
      title: "peak direction",
      graph: "direction",
      measurement: "°",
      toFixed: "0"
    },
    meanDirection: {
      title: "mean direction",
      graph: "spread",
      measurement: "°",
      toFixed: "0"
    },
    peakDirectionalSpread: {
      title: "peak spread",
      graph: "spread",
      measurement: "°",
      toFixed: "0"
    },
    meanDirectionalSpread: {
      title: "mean spread",
      graph: "direction",
      measurement: "°",
      toFixed: "0"
    }
  };

  const spotterDataPointKeys = [
    "significantWaveHeight",
    "peakPeriod",
    "meanPeriod",
    "peakDirection",
    "meanDirection",
    "peakDirectionalSpread",
    "meanDirectionalSpread"
  ];
  const pointDataPointKeys = [
    "waveHeight",
    "period",
    "meanDirection",
    "spread"
  ];

  if (spotterData) {
    // filteredSpotterData = spotterData.waves[0].filter(item => spotterDataPointKeys.indexOf(Object.keys(item)) === -1);
    filteredSpotterData = Object.keys(spotterData.waves[0])
      .filter(key => spotterDataPointKeys.includes(key))
      .reduce((obj, key) => {
        obj[key] = spotterData.waves[0][key];
        return obj;
      }, {});
  }

  const togglePane = open => event => {
    togglePaneClass();
  };

  const togglePaneClass = () => {
    setIsPaneToggled(!isPaneToggled);
  };

  useEffect(() => {
    if (spotterData) return;

    client
      .query({
        fetchPolicy: "cache-first",
        query: GET_BEST_TIME_SLICE_GEO,
        context: { clientName: "wexGeo" },
        variables: {
          start: moment()
            .startOf("hour")
            .subtract(1, "hour"),
          end: moment().startOf("hour"),
          location: { longitude: pointData[0] + 360, latitude: pointData[1] }
        },
        onError: e => console.error(`use query: ${e}`)
      })
      .then(res => setBatchedData(res.data));
  }, [client, pointData, spotterData]);

  useEffect(() => {
    if (pointData) return;

    let fetchLoad = true;

    const fetchSpotterWaveData = async () => {
      const res = await fetch(
        `${config.wavefleetUrl}/oceans-api/wave-data?spotterId=${selectedSpotter.spotterId}&startDate=${startDate}&endDate=${endDate}`,
        {
          method: "GET",
          headers: new Headers({
            token: profile.token
          })
        }
      );

      let data = await res.json();
      return data;
    };

    /* paging fetch - single spotter data for graph */
    fetchSpotterWaveData().then(data => {
      if (fetchLoad) {
        let tempArr = data.data.waves.map(record => record);
        setObservationData([...tempArr]);
      }
    });

    setObservationData(null);
    return () => (fetchLoad = false);
  }, [pointData, selectedSpotter, selectedData.selectedGraph]);

  // console.log(filteredSpotterData);
  // console.log(queriedData);

  return (
    <div
      className={
        isPaneToggled
          ? `datapane-container-mobile datapane-container-mobile-toggle`
          : "datapane-container-mobile"
      }
      id="datapane-container-mobile"
    >
      {spotterData && observationData ? (
        <React.Fragment>
          <Button className={classes.paneButton} onClick={togglePane()}>
            {isPaneToggled ? (
              <ArrowDropDownIcon style={{ color: "#C4C4C4" }} />
            ) : (
              <ArrowDropUpIcon style={{ color: "#C4C4C4" }} />
            )}
          </Button>
          <Grid className={classes.pane}>
            <Grid item>
              <Card className={classes.root}>
                <DataTitleCard
                  spotterName={spotterData.spotterId}
                  spotterTime={spotterData.track[0].timestamp}
                  spotterTrack={[
                    spotterData.track[0].latitude,
                    spotterData.track[0].longitude
                  ]}
                />
              </Card>
            </Grid>
          </Grid>
          <div
            className={
              isPaneToggled
                ? `datapane-mobile-scrollable datapane-mobile-scrollable-toggle`
                : "datapane-mobile-scrollable"
            }
          >
            {spotterDataPointKeys.map((data, index) => {
              let graphName = data;
              return (
                <Grid key={data} className={classes.pane}>
                  <Grid item>
                    <Card className={classes.root}>
                      <span onClick={e => setSelectedIndex(index)}>
                        <DataCardMobile
                          data={filteredSpotterData[data]}
                          dataType={dataPoints[data]}
                          displayData={selectedIndex === index ? false : true}
                        />
                      </span>
                      <span
                        className={
                          selectedIndex === index
                            ? "datapane-mobile-scrollable-display"
                            : "datapane-mobile-scrollable-hide"
                        }
                      >
                        <GraphDataCardPaneMobile
                          spotter={spotterData}
                          graphName={graphName}
                        />
                        <DataCardGraphMobile
                          endDate={endDate}
                          graphName={graphName}
                          observationData={observationData.map(fetchedData => ({
                            data: fetchedData[graphName],
                            timestamp: fetchedData.timestamp
                          }))}
                          latitude={spotterData.track[0].latitude}
                          longitude={spotterData.track[0].longitude}
                          selectedGraph={dataPoints[data].graph}
                          startDate={startDate}
                        />
                      </span>
                    </Card>
                  </Grid>
                </Grid>
              );
            })}
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {batchedData && (
            <React.Fragment>
              <Button className={classes.paneButton} onClick={togglePane()}>
                {isPaneToggled ? (
                  <ArrowDropDownIcon style={{ color: "#C4C4C4" }} />
                ) : (
                  <ArrowDropUpIcon style={{ color: "#C4C4C4" }} />
                )}
              </Button>
              <Grid className={classes.pane}>
                <Grid item>
                  <Card className={classes.root}>
                    <DataTitleCard
                      spotterName={
                        pointData[0] < -180
                          ? `${pointData[1].toFixed(2)}, ${(
                              pointData[0] + 360
                            ).toFixed(2)}`
                          : `${pointData[1].toFixed(2)}, ${pointData[0].toFixed(
                              2
                            )}`
                      }
                      spotterTrack={pointData}
                    />
                  </Card>
                </Grid>
              </Grid>
              <div
                className={
                  isPaneToggled
                    ? `datapane-mobile-scrollable datapane-mobile-scrollable-toggle`
                    : "datapane-mobile-scrollable"
                }
              >
                {pointDataPointKeys.map((data, index) => {
                  const graphName = data;
                  return (
                    <Grid
                      key={data}
                      onClick={e =>
                        setSelectedData({
                          ...selectedData,
                          selectedGraph: dataPoints[data].graph
                        })
                      }
                      className={classes.pane}
                    >
                      <Grid item>
                        <Card className={classes.root}>
                          <span onClick={e => setSelectedIndex(index)}>
                            <DataCardMobile
                              data={batchedData[data][0].value}
                              dataType={dataPoints[data]}
                              displayData={
                                selectedIndex === index ? false : true
                              }
                            />
                          </span>
                          <span
                            className={
                              selectedIndex === index
                                ? "datapane-mobile-scrollable-display"
                                : "datapane-mobile-scrollable-hide"
                            }
                          >
                            <GraphDataCardPaneMobile graphName={graphName} />
                            <DataCardGraphMobile
                              graphName={graphName}
                              endDate={endDate}
                              pointData={pointData}
                              selectedGraph={dataPoints[data].graph}
                              startDate={startDate}
                            />
                          </span>
                        </Card>
                      </Grid>
                    </Grid>
                  );
                })}
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default DataPane;
